import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { faTimes, faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';


@Component({
  selector: 'app-dialog-refund-confirm',
  templateUrl: './dialog-partial-refund-confirm.component.html',
  styleUrls: ['./dialog-partial-refund-confirm.component.scss']
})
export class DialogPartialRefundConfirmComponent {

  faTriangleExclamation = faTriangleExclamation;
  faTimes = faTimes;

  constructor(public dialogRef: MatDialogRef<DialogPartialRefundConfirmComponent>) { }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
